// import React, { useEffect } from "react";

// import {
//     createColumnHelper,
//     useReactTable,
//     getCoreRowModel,
//     getFilteredRowModel,
//     getFacetedRowModel,
//     getFacetedUniqueValues,
//     getFacetedMinMaxValues,
//     getPaginationRowModel,
//     getSortedRowModel,
//     flexRender,
// } from "@tanstack/react-table";
// import Select from "components/fields/Select";

// const columnHelper = createColumnHelper();

// const Occupancy = () => {
//     const [globalFilter, setGlobalFilter] = React.useState("");
//     const [columnFilters, setColumnFilters] = React.useState([]);
//     const [{ pageIndex, pageSize }, setPagination] = React.useState({
//         pageIndex: 0,
//         pageSize: 6,
//     });
//     const [data, setData] = React.useState([]);
//     useEffect(() => {
//       setData([
//         {name: "Room name", campus: "Campaus Name", datetime: new Date(), occupancy: parseInt(Math.random() * 100)},
//         {name: "Room name", campus: "Campaus Name", datetime: new Date(), occupancy: parseInt(Math.random() * 100)},
//         {name: "Room name", campus: "Campaus Name", datetime: new Date(), occupancy: parseInt(Math.random() * 100)},
//       ]);
//     }, [])
//     const pagination = React.useMemo(
//         () => ({
//           pageIndex,
//           pageSize,
//         }),
//         [pageIndex, pageSize]
//     );

//     const columns = [
//         columnHelper.accessor("name", {
//           id: "name",
//           header: () => (
//             <p className="text-sm font-bold text-gray-600 dark:text-white">NAME</p>
//           ),
//           cell: (info) => (
//             <div className="font-medium text-gray-800 dark:text-white">
//               {info.getValue()}
//             </div>
//           ),
//         }),
//         columnHelper.accessor("campus", {
//           id: "campus",
//           header: () => (
//             <p className="text-sm font-bold text-gray-600 dark:text-white">CAMPUS</p>
//           ),
//           cell: (info) => (
//             <p className="text-sm text-navy-700 dark:text-white">
//               {info.getValue()}
//             </p>
//           ),
//         }),
//         columnHelper.accessor("occupancy", {
//           id: "occupancy",
//           header: () => (
//             <p className="text-sm font-bold text-gray-600 dark:text-white">OCCUPANCY</p>
//           ),
//           cell: (info) => (
//             <div
//               className={`flex h-7 inline-block w-fit pl-5 pr-5 items-center justify-center text-sm ${
//                 info.getValue() < 85
//                   ? "bg-green-100 dark:bg-green-50"
//                   : "bg-red-100 dark:bg-red-50"
//               } rounded-[10px] text-base font-bold `}
//             >
//               <div className={info.getValue() < 85 ? "text-brand-800 " : "text-red-500"}>
//                 {`${info.getValue()} %`}
//               </div>
//             </div>
//           ),
//         }),
//       ]; // eslint-disable-next-line

//     const table = useReactTable({
//         data,
//         columns,
//         state: {
//           columnFilters,
//           globalFilter,
//           pagination,
//         },
//         onPaginationChange: setPagination,
//         onColumnFiltersChange: setColumnFilters,
//         onGlobalFilterChange: setGlobalFilter,
//         getCoreRowModel: getCoreRowModel(),
//         getFilteredRowModel: getFilteredRowModel(),
//         getSortedRowModel: getSortedRowModel(),
//         getPaginationRowModel: getPaginationRowModel(),
//         getFacetedRowModel: getFacetedRowModel(),
//         getFacetedUniqueValues: getFacetedUniqueValues(),
//         getFacetedMinMaxValues: getFacetedMinMaxValues(),
//         debugTable: true,
//         debugHeaders: true,
//         debugColumns: false,
//     });

//     return (
//         <>
//             <div className="p-3">
//                 <div className="flex gap-[30px] mt-5">
//                     <div className="w-[320px] h-[48px]">
//                         <input
//                             type="text"
//                             placeholder="Find by user name"
//                             className="block p-4 h-full w-full rounded-2xl bg-lightPrimary text-sm font-medium text-navy-700 outline-none placeholder:!text-gray-400 dark:bg-navy-900 dark:text-white dark::placeholder:!text-gray-700"
//                         />
//                     </div>

//                     <Select>
//                         <option>All roles</option>
//                     </Select>

//                     <Select>
//                         <option>All time</option>
//                     </Select>
//                 </div>
//             </div>

//             <div className="mt-5">
//                 <div className="mt-8 overflow-x-scroll xl:overflow-x-hidden">
//                     <table className="w-full">
//                     <thead>
//                         {table.getHeaderGroups().map((headerGroup) => (
//                         <tr key={headerGroup.id} className="!border-px !border-gray-400">
//                             {headerGroup.headers.map((header) => {
//                             return (
//                                 <th
//                                 key={header.id}
//                                 colSpan={header.colSpan}
//                                 onClick={header.column.getToggleSortingHandler()}
//                                 className="cursor-pointer border-b border-gray-200 pb-2 pr-4 pt-4 text-start dark:border-white/30"
//                                 >
//                                 <div className="items-center justify-between text-xs text-gray-200">
//                                     {flexRender(
//                                     header.column.columnDef.header,
//                                     header.getContext()
//                                     )}
//                                     {{
//                                     asc: "",
//                                     desc: "",
//                                     }[header.column.getIsSorted()] ?? null}
//                                 </div>
//                                 </th>
//                             );
//                             })}
//                         </tr>
//                         ))}
//                     </thead>
//                     <tbody>
//                         {table
//                         .getRowModel()
//                         .rows
//                         .map((row) => {
//                             return (
//                             <tr
//                                 key={row.id}
//                                 className="border-b border-gray-200 dark:border-white/30"
//                             >
//                                 {row.getVisibleCells().map((cell) => {
//                                 return (
//                                     <td
//                                     key={cell.id}
//                                     className="min-w-[150px] border-white/0 py-3  pr-4"
//                                     >
//                                     {flexRender(
//                                         cell.column.columnDef.cell,
//                                         cell.getContext()
//                                     )}
//                                     </td>
//                                 );
//                                 })}
//                             </tr>
//                             );
//                         })}
//                     </tbody>
//                     </table>
//                 </div>

//                 <p>TODO: pagination / remote data</p>
//             </div>
//         </>
//     )
// }

// export default Occupancy;

import React, { useEffect, useState, useMemo } from "react";
import GlobalTable from "components/global-table";

const Occupancy = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    setData([
      {
        name: "Room name",
        campus: "Campus name",
        occupancy: parseInt(Math.random() * 100),
      },
      {
        name: "Room name",
        campus: "Campus name",
        occupancy: parseInt(Math.random() * 100),
      },
      {
        name: "Room name",
        campus: "Campus name",
        occupancy: parseInt(Math.random() * 100),
      },
    ]);
  }, []);

  const columns = useMemo(
    () => [
      {
        id: "name",
        label: "Name",
        render: (row) => (
          <span className="text-navy-700 dark:text-white">{row.name}</span>
        ),
      },
      {
        id: "campus",
        label: "Campus",
      },
      {
        id: "occupancy",
        label: "Occupancy",
        render: (row) => (
          <div
            className={`inline-block w-fit px-4 py-1 text-sm capitalize rounded-xl font-bold ${
              row.occupancy < 85
                ? "bg-green-100 text-green-600"
                : "bg-red-100 text-red-600"
            }`}
          >
            {row.occupancy}%
          </div>
        ),
      },
    ],
    []
  );

  return (
    <>
      <div className="p-3">
        <div className="flex flex-wrap gap-3 mt-5">
          <div className="w-[320px] h-[48px]">
            <input
              type="text"
              placeholder="Find by user name"
              className="block p-4 h-full w-full rounded-2xl bg-lightPrimary text-sm font-medium text-navy-700 outline-none placeholder:!text-gray-400 dark:bg-navy-900 dark:text-white dark:placeholder:!text-gray-700"
            />
          </div>

          <div className="flex gap-3 flex-none">
            <form className="max-w-sm mx-auto">
              <select
                id="roles"
                className="bg-gray-50 border border-gray-300 text-gray-700 outline-none text-sm rounded-lg block w-full p-2.5 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
              >
                <option defaultValue>All roles</option>
                <option value="Volunteer">Volunteer</option>
                <option value="Admin">Admin</option>
              </select>
            </form>
            <form className="max-w-sm mx-auto">
              <select
                id="time"
                className="bg-gray-50 border border-gray-300 text-gray-700 outline-none text-sm rounded-lg block w-full p-2.5 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
              >
                <option defaultValue>All time</option>
                <option value="Today">Today</option>
                <option value="This Week">This Week</option>
              </select>
            </form>
          </div>
        </div>
      </div>

      <div className="mt-6">
        <GlobalTable columns={columns} data={data} />
      </div>

      <div className="flex items-center justify-between">
        <div className="flex mt-8 gap-4 items-center">
          <p className="ml-8 text-navy-700">Show rows per page</p>
          <form className="max-w-sm mx-auto">
            <select
              id="rows"
              className="bg-gray-50 border border-gray-300 text-navy-700 outline-none text-sm rounded-lg block p-1 dark:border-navy-700 dark:text-white"
            >
              <option defaultValue>10</option>
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
            </select>
          </form>
        </div>
        <div className="mr-12">
          <p className="text-gray-600">
            <span className="text-navy-700">1-3 </span> of 3
          </p>
        </div>
      </div>
    </>
  );
};

export default Occupancy;
